import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Question, Option, ReplyItem } from '../../../../classes';

@Component({
  selector: '[table-question]',
  template: '<ng-content></ng-content>'
})
export class QuestionComponent implements OnInit, OnDestroy {
  @Input() question: Question;
  @Input() item: ReplyItem;
  constructor() {}
  subscriptions: Subscription[] = [];
  ngOnInit() {}
  ngOnDestroy() {}
  TrackByIdFn(index: number, option: Option) {
    return option.id;
  }
}
